/**
 * Helpers puros para manipular o conteúdo de um <textarea> a partir da seleção
 * atual, usados pela barra de ferramentas do editor de posts. Cada função recebe
 * o valor + seleção e devolve `{ value, selectionStart, selectionEnd }` — quem
 * chama atualiza o estado React e restaura o cursor.
 */

/** Envolve a seleção com `before`/`after`. Sem seleção, insere `placeholder`. */
export function wrapSelection(value, start, end, before, after, placeholder = "") {
    const selected = value.slice(start, end) || placeholder;
    const newValue = value.slice(0, start) + before + selected + after + value.slice(end);
    const innerStart = start + before.length;
    const innerEnd = innerStart + selected.length;
    return { value: newValue, selectionStart: innerStart, selectionEnd: innerEnd };
}

/** Adiciona um prefixo (ex.: "## ", "- ", "> ") ao início de cada linha selecionada. */
export function prefixLines(value, start, end, prefix) {
    const lineStart = value.lastIndexOf("\n", start - 1) + 1;
    const block = value.slice(lineStart, end);
    const prefixed = block
        .split("\n")
        .map((line) => prefix + line)
        .join("\n");
    const newValue = value.slice(0, lineStart) + prefixed + value.slice(end);
    return {
        value: newValue,
        selectionStart: lineStart + prefix.length,
        selectionEnd: lineStart + prefixed.length,
    };
}

/** Insere um bloco isolado (imagem, vídeo) garantindo linhas em branco ao redor. */
export function insertBlock(value, start, end, text) {
    const before = value.slice(0, start);
    const after = value.slice(end);
    const needsLeading = before && !before.endsWith("\n\n");
    const needsTrailing = after && !after.startsWith("\n\n");

    const lead = before ? (before.endsWith("\n") ? "\n" : "\n\n") : "";
    const trail = after ? (after.startsWith("\n") ? "\n" : "\n\n") : "";

    const block = (needsLeading ? lead : "") + text + (needsTrailing ? trail : "");
    const newValue = before + block + after;
    const cursor = before.length + (needsLeading ? lead.length : 0) + text.length;
    return { value: newValue, selectionStart: cursor, selectionEnd: cursor };
}
